<!--
 * @Author: 李鸿润
 * @Date: 2021-07-21 11:15:52
 * @LastEditTime: 2021-07-31 15:53:15
 * @LastEditors: Please set LastEditors
 * @Description: 价值申报基础信息
 * @FilePath: \hpss-ui\src\views\crmedical\value\valuedeclare\declareBaseInfo.vue
-->

<template>
    <div style="width:100%">
       <div class="title"> <h1>华润医疗医院后勤价值型管理方案申报表</h1></div>
       <div class="content">
        <!-- <avue-form ref="form" v-model="baseInfoForm" :option="option" @reset-change="emptytChange" @submit="submit">
        </avue-form> -->
        <div >
            <el-form ref="baseInfoFormRef" :model="baseInfoForm"  :rules="baseInfoFormRules" label-width="80px">
              <el-row :gutter="24">
                <el-col :span="24">
                  <el-form-item label="申报单位" prop="projectName">
                    <el-input v-model="baseInfoForm.projectName" disabled></el-input>
                </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="申报人" prop="submitName">
                    <el-input v-model="baseInfoForm.submitName"></el-input>
                </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="手机" prop="submitMobile">
                    <el-input v-model="baseInfoForm.submitMobile"></el-input>
                </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="邮箱" prop="submitEmail">
                    <el-input v-model="baseInfoForm.submitEmail"></el-input>
                </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="申报日期" prop="declareTime">
                     <el-date-picker
                    v-model="baseInfoForm.declareTime"
                    type="date"
                    value-format="yyyy-MM-dd hh:mm:ss"
                    placeholder="选择日期">
                    </el-date-picker>
                </el-form-item>
                </el-col>
                <el-col>
                  <div class="cycleArea" >
                  <el-form-item label="起止周期" prop="periodStart" >
                      <el-date-picker
                        style="width: 200px;"
                        v-model="baseInfoForm.periodStart"
                        type="year"
                        value-format="yyyy"
                        @blur="emitCycleValidate"
                        placeholder="选择年" >
                      </el-date-picker>
                </el-form-item>
                <span style="margin-top:6px">至</span>
                <el-form-item prop="periodEnd" id="periodEnd">
                    <el-date-picker
                      style="width: 200px;margin-left:-75px"
                      v-model="baseInfoForm.periodEnd"
                      type="year"
                      value-format="yyyy"
                      @blur="emitCycleValidate"
                      placeholder="选择年">
                    </el-date-picker>
                  
                </el-form-item>
                </div>
                </el-col>
              </el-row>
            </el-form>
        </div>
       </div>
    </div>
</template>

<script>
import { saveValueInfo } from '@/api/crmedical/value/valuebudget';
export default {
  props: {
    editDetailInfo: {},
  },
  created() {
    for (const key in this.baseInfoForm) {
      this.baseInfoForm[key] = this.editDetailInfo[key];
    }
  },
  mounted() {},
  data() {
    var telValidatePass = (rule, value, callback) => {
      let reg = /^1(?:3\d|4[4-9]|5[0-35-9]|6[67]|7[013-8]|8\d|9\d)\d{8}$/;
      if (reg.test(value)) {
        callback();
      } else {
        callback(new Error('输入电话格式不正确'));
      }
    };

    var cycleValidatePass = (rule, value, callback) => {
      let periodStart = this.baseInfoForm.periodStart;
      let periodEnd = this.baseInfoForm.periodEnd;
      console.log('周期验证', periodStart, '结束', periodEnd);
      if (!value) {
        callback(new Error('周期不能为空'));
      } else if (periodStart > periodEnd) {
        callback(new Error('开始周期必须小于截至周期'));
      } else {
        callback();
      }
    };
    return {
      validateFlag: false, //表单验证状态
      refList: ['baseInfoFormRef'],
      baseInfoForm: {
        id: '',
        projectName: '',
        submitName: '',
        submitMobile: '',
        submitEmail: '',
        declareTime: '',
        periodStart: '', //周期开始时间
        periodEnd: '', //周期结束时间
        projectId: '',
      },
      baseInfoFormRules: {
        projectName: [{ required: true, message: '请输入申报单位', trigger: 'blur' }],
        submitName: [{ required: true, message: '请输入申报人', trigger: 'blur' }],
        submitMobile: [
          { required: true, message: '请输入电话', trigger: 'blur' },
          { validator: telValidatePass, trigger: 'blur' },
        ],
        submitEmail: [
          { required: true, message: '请输入邮箱', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] },
        ],
        declareTime: [{ required: true, message: '请输入申报日期', trigger: 'blur' }],
        periodStart: [{ required: true, message: '周期不能为空', trigger: 'blur' },{ validator: cycleValidatePass, trigger: 'blur' }],
        periodEnd: [{ validator: cycleValidatePass, trigger: 'blur' }],
      },
    };
  },
  methods: {
    //周期验证触发
    emitCycleValidate() {
      this.$refs['baseInfoFormRef'].validateField(['periodEnd'], (Error) => {
        if (!Error) {
          //执行
        } else {
        }
      });
      this.$refs['baseInfoFormRef'].validateField(['periodStart'], (Error) => {
        if (!Error) {
          //执行
        } else {
        }
      });
    },
    //（保存）提交
    async submit() {
      this.refList.forEach((item) => {
        this.$refs[item].validate((valid) => {
          if (valid) {
            this.validateFlag = true;
          } else {
            this.validateFlag = false;
          }
        });
      });
      if (this.validateFlag) {
        await saveValueInfo(Object.assign(this.baseInfoForm))
          .then((data) => {
            if (data.code == 200) {
              this.editDetailInfo.id = data.data;
              this.baseInfoForm.id = this.editDetailInfo.id
              this.$message({
                showClose: true,
                message: '数据保存成功',
                type: 'success',
              });

              this.validateFlag = true;
            } else {
              this.validateFlag = false;
            }
          })
          .catch((err) => {
            // return false;
            this.validateFlag = false;
          });
      } else {
        this.$message({
          showClose: true,
          message: '请将数据填写完整',
          type: 'error',
        });

        this.validateFlag = false;
      }

      return this.validateFlag;
    },

    //预览
    preview() {},
  },
};
</script>

<style  scoped>
::v-deep #periodEnd .el-form-item__error{
  left: -72px;
}

.cycleArea {
  /* background: red; */
  display: flex;
}
.title {
  margin: 0 auto;
  text-align: center;
}
.content {
  width: 40%;
  /* display: flex;
    justify-content: center;
    align-content: center; */
  margin: 0 auto;
}
</style>
<style>
</style>

